import React, { useEffect, useState, useRef } from "react";
import { localize } from "redux-i18n";
import PropTypes from "prop-types";
import { Field, reduxForm, formPropTypes } from "redux-form";
import { compose } from "redux";
import { connect } from "react-redux";
import { TextField, DatePickerFormWrapper, Dropdown } from "@components/form";
import { Form, FormGroup, Label, Button, View } from "@components";
import { numericality } from "redux-form-validators";
import { wrapperValidate } from "@components/form/validators";
import "./employee-filter.style.scss";
import actionCreators from "@modules/employee/actionCreator";

type Props = {
  employees: Array<Object>,
  disabled: boolean,
  reset: Function,
  onReset: Function,
  handleSubmit: Function,
};

export function EmployeeFilter(props: Props) {
  const formRef = useRef();

  function resetForm() {
    props.reset();
    props.onReset();
  }
  return (
    <Form ref={formRef} onSubmit={props.handleSubmit} className="employee-filters">
      <FormGroup>
        <Label for="lastName">{props.t("SURNAME")}</Label>
        <Field
          id="lastName"
          name="lastName"
          disabled={props.disabled}
          component={TextField}
          type="text"
        />
      </FormGroup>
      <FormGroup className="wider">
        <Label for="dateOfBirth">{props.t("DATE_OF_BIRTH")}</Label>
        <Field
          disabled={props.disabled}
          name="dateOfBirth"
          customProps={{
            id: "dateOfBirth",
          }}
          component={DatePickerFormWrapper}
        />
      </FormGroup>
      <FormGroup>
        <Label for="employeeRefPrimary">{props.t("EMPLOYEE_REF")}</Label>
        <Field
          id="employeeRefPrimary"
          disabled={props.disabled}
          name="employeeRefPrimary"
          component={TextField}
          type="text"
        />
      </FormGroup>
      <FormGroup>
        <Label for="organisationalUnit">{props.t("DEPARTMENT")}</Label>
        <Field
          id="organisationalUnit"
          name="organisationalUnit"
          disabled={props.disabled}
          component={TextField}
          type="text"
        />
      </FormGroup>
      <FormGroup>
        <Label for="userId">{props.t("USER_ID")}</Label>
        <Field
          id="userId"
          disabled={props.disabled}
          name="id"
          component={TextField}
          type="number"
          min={1}
        />
      </FormGroup>
      <FormGroup className="wider">
        <Label for="isActive">{props.t("STATUS")}</Label>
        <Field
          id="isActive"
          disabled={props.disabled}
          name="isActive"
          component={Dropdown}
          // onChange={changeSelect}
          options={[
            { value: "", label: "All" },
            { value: "true", label: "Active only" },
            { value: "false", label: "Inactive only" },
          ]}
        />
      </FormGroup>
      <FormGroup>
        <Label for="absenceId">{props.t("ABSENCE_ID")}</Label>
        <Field
          id="absenceId"
          disabled={props.disabled}
          name="absenceId"
          component={TextField}
          min={1}
          type="number"
        />
      </FormGroup>
      <FormGroup className="wider">
        <Label for="email">{props.t("EMAIL_ADDRESS")}</Label>
        <Field
          id="email"
          disabled={props.disabled}
          name="email"
          component={TextField}
          type="text"
        />
      </FormGroup>
      <FormGroup className="wider">
        <Label for="homeMobile">{props.t("PHONE_NUMBER")}</Label>
        <Field
          id="homeMobile"
          disabled={props.disabled}
          name="homeMobile"
          component={TextField}
          type="text"
        />
      </FormGroup>
      <FormGroup className="d-flex">
        <View direction="row">
          <Button materialIcon="replay_circle_filled">{props.t("SUBMIT")}</Button>
          {props.dirty && (
            <Button disabled={props.disabled} color="secondary" onClick={resetForm}>
              {props.t("RESET")}
            </Button>
          )}
        </View>
      </FormGroup>
    </Form>
  );
}

EmployeeFilter.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  ...formPropTypes,
  options: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  resetButton: PropTypes.bool,
  onReset: PropTypes.func.isRequired,
};

const validations = {
  id: [
    numericality({
      int: true,
      ">=": 1,
      allowBlank: true,
    }),
  ],
};

const validate = wrapperValidate(validations);

export default compose(
  localize(),
  reduxForm({
    form: "employee-filter",
    enableReinitialize: true,
    initialValues: { isActive: "true" },
    validate,
  }),
)(EmployeeFilter);
